import * as R from 'ramda'
import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'

import FundraisingHeroProgress from '../../components/FundraisingHeroProgress'
import ProjectDetailHero from '../../components/ProjectDetailHero'
import { OrgAvatarInfo } from '../../components/ProjectDetailHero/HeroAvatar'
import { useTracking } from '../../hooks'
import { orgSelector, projectSelector } from '../../redux/project/selectors'
import { detailClickHero } from '../../utils/dataTracker'
import CatIcons from '../CategoryIcon/CatIcons'

const FeaturedProject = ({ projectNo, ...props }) => {
  const track = useTracking()

  const projectData = useSelector(
    state => projectSelector(state, projectNo),
    R.equals
  )

  const organizationData = useSelector(
    state => orgSelector(state, projectData.organizationNo),
    R.equals
  )

  const {
    name,
    mainImg,
    projectPromoCategory,
    startTime,
    donationTarget,
    donors,
    donorCount,
    projectType,
    projectStatus,
    projectDetailHeroStatusDescription,
    organizationNo,
    donationCount,
    totalDonatedAmount
  } = projectData

  const { avatar, name: orgName, noOfProject } = organizationData

  const handleOrgLinkClick = useCallback(() => {
    track(detailClickHero('organization', organizationNo, projectNo, name))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationNo, projectNo, name])

  return R.isNil(projectData) ? null : (
    <ProjectDetailHero
      title={name}
      mainImg={mainImg}
      avatar={
        <OrgAvatarInfo
          avatar={avatar}
          name={orgName}
          organizationNo={organizationNo}
          projectCount={noOfProject}
          onLinkClick={handleOrgLinkClick}
        />
      }
      catIcons={
        <CatIcons
          projectPromoCategory={projectPromoCategory}
          projectNo={projectNo}
          projectName={name}
        />
      }
      fundraisingHeroProgress={
        <FundraisingHeroProgress
          startTime={startTime}
          donationTarget={donationTarget}
          donors={donors}
          donorCount={donorCount}
          projectType={projectType}
          projectStatus={projectStatus}
          projectDetailHeroStatusDescription={
            projectDetailHeroStatusDescription
          }
          donationCount={donationCount}
          totalDonatedAmount={totalDonatedAmount}
        />
      }
    />
  )
}

export default FeaturedProject
